import { getQueryVariable } from "./_global";

// PDP variants dropdown
$(document).ready(function () {

  //swiper on PDP page
  var pdpSwiper = new Swiper('[data-pdp-swiper]', {
    // navigation: {
    //   nextEl: '.swiper-button-next',
    //   prevEl: '.swiper-button-prev',
    // },
    allowTouchMove: false,

    lazy: true
  });


  //variant swatches swiper on PDP page
  var pdpVariantSwiper = new Swiper('[data-pdp-variant-swiper]', {
    navigation: {
      nextEl: '.pdp-variant-swiper .swiper-button-next',
      prevEl: '.pdp-variant-swiper .swiper-button-prev',
    },
    lazy: true,
    init: false
  });

  var els = {
    $selected: $('[data-pdp-vars-selected]'),
    $selectedConf1: $('[data-pdp-vars-selected-conf1-val]'),
    $selectedConf2: $('[data-pdp-vars-selected-conf2-val]'),
    $selectedConf3: $('[data-pdp-vars-selected-conf3-val]'),
    $selectedVarantDownload: $('[data-selected-varant-download]'),
    $selectedImg: $('[data-pdp-vars-selected-img]'),
    $variantOptions: $('[data-pdp-variant]'),
    $dropdown: $('[data-pdp-variants-dropdown]'),
    $price: $('[data-price]'),
    $regPrice: $('[data-regular-price]'),
    $salePrice: $('[data-sale-price]'),
    $input: $('[data-pdp-variant-input]'),
    $swiperBtn: $('[data-show-pdp-swiper]'),
    $variantBtn: $('[data-show-variant-swiper]'),
    $variantSwiperWrapper: $('[data-pdp-variant-swiper-wrapper]'),
    $addToCartBtn: $('[data-add-to-cart]'),
    $addToCartText: $('[data-add-to-cart-text]'),
    $deliveryDetail: $('[data-delivery-detail]'),
    $lightBoxBtn: $('[data-show-light-box]'),
    $lightBoxCloseBtn: $('[data-show-light-box-close]'),
    $lightBox: $('[data-pdp-light-box]'),

    $tabsLink: $('[data-pdp-tabs-link]')

  }

  var classes = {
    showDropdown: 'pdp-variants__dropdown--show',
    priceOnSale: 'price--on-sale'
  }

  var selectors = {
    variantSwiper: '[data-pdp-variant-swiper]',
    pdpSwiper: '[data-pdp-swiper]'
  }

  var $activeVariant, swiperId;

  var variantSlide = document.getElementById("pdp-variant-slide") && Handlebars.compile(document.getElementById("pdp-variant-slide").innerHTML);

  var closeDropdown = function () {
    els.$dropdown.removeClass(classes.showDropdown);
    els.$dropdown.slideUp(200)

    window.removeEventListener('click', closeDropdown);
  }

  var openDropdown = function () {
    els.$dropdown.addClass(classes.showDropdown);
    els.$dropdown.slideDown(200)

    window.addEventListener('click', closeDropdown);
  }

  var setSwiperSlide = function (swiperId) {
    var swiperSlide = $(`[data-slide-id="${swiperId}"]`);
    var slideIndex = swiperSlide.data('slideIndex');
    pdpSwiper.forEach(function (swiper) {
      swiper.slideTo(slideIndex);
    });
  }

  if (getQueryVariable('variant')) {
    $activeVariant = $(`[data-pdp-variant="${getQueryVariable('variant')}"]`);
    swiperId = $activeVariant.data('pdpVariantSwiperId');

    //slide swiper to slide with variant image
    if (swiperId) {
      setSwiperSlide(swiperId);
    }
  }

  els.$swiperBtn.on('click', function () {
    var $pdpSwiper = $(this).parent().parent().find(selectors.pdpSwiper);
    var $variantSwiper = $(this).parent().parent().find(selectors.variantSwiper);
    $variantSwiper.fadeOut(500, function () {
      $pdpSwiper.fadeIn(500, function () {

        // swap out content of swatches swiper to new variant
        $.each(pdpSwiper, function (index, swiper) {
          swiper.lazy.load();
        });
      });
    });
  });

  els.$variantBtn.on('click', function () {
    var $pdpSwiper = $(this).parent().parent().find(selectors.pdpSwiper);
    var $variantSwiper = $(this).parent().parent().find(selectors.variantSwiper);
    $pdpSwiper.fadeOut(500, function () {
      $variantSwiper.fadeIn(500);
      $.each(pdpVariantSwiper, function (index, swiper) {
        if (!swiper.initialized) swiper.init();
        else swiper.update();
        swiper.lazy.load();
      });
    });
  });

  els.$variantOptions.on('click', function (e) {
    var $variant = $(this);

    var swiperId = $variant.data('pdpVariantSwiperId');
    var swatchImages = $variant.data('pdpVariantSwatches').split(',');
    var swatchImageNames = $variant.data('pdpVariantSwatchNames').split(',');
    var swatchImagesHtml = '';

    $('.product-variant-modal__variants-item').removeClass('selected');
    $variant.addClass('selected');

    //slide swiper to slide with variant image
    if (swiperId) {
      setSwiperSlide(swiperId);
    }

    $('.wishlist-btn').attr('data-selected-variant-id', $variant.data('pdpVariant'));

    const variantDownloadLink = $variant.data('pdpVariantDownload') || null;
    const variantOption_1 = $variant.data('pdpVariantConf1Val') || null;
    const variantOption_2 = $variant.data('pdpVariantConf2Val') || null;
    const variantOption_3 = $variant.data('pdpVariantConf3Val') || null;
    const variantOptions = [variantOption_1,variantOption_2, variantOption_3].filter(Boolean);
    const selectedVarientTitle = variantOptions.join(" / ");

    els.$selectedVarantDownload.parent('.product__varient-download').hide();
    if (variantDownloadLink) {
      els.$selectedVarantDownload.attr("href", variantDownloadLink).parent('.product__varient-download').show();
    }

    els.$selectedConf1.text(selectedVarientTitle);
    els.$selectedConf2.text($variant.data('pdpVariantConf2Val'));
    els.$selectedConf3.text($variant.data('pdpVariantConf3Val'));
    els.$selectedImg.html($variant.find('[data-pdp-variant-img]').html());

    if ($variant.data('pdpVariantCompareAtPrice')) {
      els.$price.addClass(classes.priceOnSale);
      els.$regPrice.html(`<s>${$variant.data('pdpVariantCompareAtPrice')}</s>`);
      els.$salePrice.text($variant.data('pdpVariantPrice'));
    } else {
      els.$price.removeClass(classes.priceOnSale);
      els.$regPrice.text($variant.data('pdpVariantPrice'));
      els.$salePrice.text('');
    }

    // update delivery text
    els.$addToCartBtn.prop('disabled', false);
    els.$addToCartBtn.removeAttr('aria-disabled');
    els.$addToCartText.text(els.$addToCartBtn.data('addToCartBtnText'));
    if ($variant.data('pdpVariantQuantity') > 0) {
      const deliveryText = `<span class='bullet bullet--green'></span> ${$variant.data('pdpVariantQuantity')} In Stock - Delivery 5-10 Days`
      els.$deliveryDetail.html(deliveryText);
    } else if ($variant.data('pdpVariantPolicy') === 'continue') {
      els.$deliveryDetail.html(els.$deliveryDetail.data('deliveryTextOrder'));
    } else {
      els.$addToCartText.text(els.$addToCartBtn.data('addToCartSoldOutBtnText'));
      els.$deliveryDetail.text('');
      els.$addToCartBtn.prop('disabled', true);
      els.$addToCartBtn.attr('aria-disabled', 'true');
    }


    // swap out content of swatches swiper to new variant
    $.each(pdpVariantSwiper, function (index, swiper) {
      if (swiper.initialized) {
        swiper.removeAllSlides();
      } else {
        els.$variantSwiperWrapper.each(function () {
          $(this).html('');
        });
      }
    });

    $.each(swatchImages, function (index, image) {
      var content = {
        swatch: image,
        swatch_name: swatchImageNames[index]
      };

      $.each(pdpVariantSwiper, function (index, swiper) {
        if (content.swatch !== '') {
          swiper.appendSlide(variantSlide(content));
        }
      });
    });

    // swap out content of swatches swiper to new variant
    $.each(pdpVariantSwiper, function (index, swiper) {
      if (swiper.lazy && swiper.lazy.load) swiper.lazy.load();
    });

    history.replaceState(null, null, "?variant=" + $variant.data('pdpVariant'));

    closeDropdown();

    els.$input.val($variant.data('pdpVariant'));

    e.stopPropagation();
  });

  els.$selected.on('click', function (e) {
    if (els.$dropdown.hasClass(classes.showDropdown)) {
      closeDropdown();
    } else {
      openDropdown();
    }
    e.stopPropagation();
  });

  els.$lightBoxBtn.on('click', function (e) {
    els.$lightBox.css("display", 'block');
    new Swiper('[data-pdp-swiper]', {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      lazy: true
    });

    e.stopPropagation();
  });

  els.$lightBoxCloseBtn.on('click', function (e) {
    els.$lightBox.css("display", 'none');
    e.stopPropagation();
  });



  $('[data-link-to-designer]').on('click', function (e) {
    $('html,body').animate({
      scrollTop: $("#shopify-section-product-info").offset().top
    },
      'slow');
  });

  $('[data-pdp-tabs-link-swatches]').on('click', function (e) {

    setTimeout(function () {
      new Swiper('[data-pdp-variant-swiper]', {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        lazy: true
      });
    }, 100);


    e.stopPropagation();
  });

  $('[data-pdp-tabs-link-product]').on('click', function (e) {

    setTimeout(function () {
      new Swiper('[data-pdp-swiper]', {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        lazy: true
      });
    }, 100);


    e.stopPropagation();
  });



});